// キーボードショートカット情報
export class KeyboardShortcut
{
    public id : string = "";
    public modifier : number = 0;
    public key : string = "";
    public callback : () => void = () => {};
    public canExecute : () => boolean = () => { return false; };

    constructor(id ,modifier, key, callback, canExecute)
    {
        this.id = id;
        this.modifier = modifier;
        this.key = key;
        this.callback = callback;
        this.canExecute = canExecute;
    }
}